<template>
  <footer class="footer">
    <div class="footer_text">
        &copy; {{ new Date().getFullYear() }} e-Tax. All Rights Reserved.
    </div>
  </footer>
</template>
<script>
export default {}

</script>
<style scoped>
    .footer{
        padding: 0
    }
    .footer_text{
        text-align: center;
        padding: 15px 0;
    }
</style>
